module.exports = __webpack_public_path__ + "static/media/praying.375c4b45.png";